import { render, staticRenderFns } from "./add_plat.vue?vue&type=template&id=38c61fe3&scoped=true&"
import script from "./add_plat.vue?vue&type=script&lang=js&"
export * from "./add_plat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c61fe3",
  null
  
)

export default component.exports